module.exports = __webpack_public_path__ + "img/btn_google_signin_focus.1c295ea4.png";